
var defaultValueToDisplayText = function(defaultValue) {
    if (!defaultValue) {
        return '';
    }

    if (typeof (defaultValue) === 'string') {
        return '= ' + defaultValue;
    }

    if (defaultValue.NewValue) {
        return '= ' + defaultValue.NewValue;
    }

    return "= *****";
};

module.exports = defaultValueToDisplayText;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/defaultValueToDisplayText.js
// module id = 2066273969125808
// module chunks = 1